import Vue from "vue";

Vue.filter("emptyReplace", function (value: any): any {
  if (value) {
    return value;
  }
  return "---";
});
